module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [(false) ? _c('div', [_vm._m(0), _vm._v("\n          |  \n        "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/morph85"
    }
  }, [_vm._v("morph / "), _c('i', {
    staticClass: "fa fa-github",
    staticStyle: {
      "vertical-align": "middle"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://ko-fi.com/A83439QF",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "border": "0px",
      "height": "26px"
    },
    attrs: {
      "height": "26",
      "src": "https://az743702.vo.msecnd.net/cdn/kofi2.png?v=0",
      "border": "0",
      "alt": "Buy Me a Coffee at ko-fi.com"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-wraper"
  }, [_c('div', {
    staticClass: "footer-block left brace",
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/noctorus.studio",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://www.twitter.com/noctorus",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://www.medium.com/@noctorus",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-medium"
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://www.github.com/morph85",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-block left brace"
  }, [_c('span', {
    staticClass: "left-brace-tl"
  }), _vm._v(" "), _c('span', {
    staticClass: "left-brace-tr"
  }), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "left-brace-bl"
  }), _vm._v(" "), _c('span', {
    staticClass: "left-brace-br"
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer-block left"
  }, [_c('i', {
    staticClass: "ficon fa fa-code"
  }), _vm._v(" "), _c('div', {
    staticClass: "fname"
  }, [_c('strong', [_vm._v("noctorus")]), _vm._v(" © 2017.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-block right"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "/terms"
    }
  }, [_vm._v("Terms of Service")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cb6070f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 815
// module chunks = 1